import React from "react";
import { Link } from "react-router-dom";
import ScheduleDemo from "./ScheduleDemo";

class Contact extends React.Component{
	render(){
		return (
			<div className="compContact" id="contact">
				<div className="compWrapper">
					<div className="col2">
						<div className="contactInfo center">
							<h3 className="compTitle">Contact Us</h3>
							<div>
								<p className="bold">PowerSchool Manager</p>
								<p>Eric Lammers</p>
							</div>
							<div>
								<p className="bold">Phone</p>
								<p>(740) 389 - 4798 Ext. 1247</p>
							</div>
							<div>
								<p className="bold">Fax</p>
								<p>(740) 389 - 4517</p>
							</div>
							<div>
								<p className="bold">Location</p>
								<p>100 Executive Drive</p>
								<p>Marion, Ohio 43302</p>
							</div>
						</div>
						<div>
							<section>
									<div id="contact_cta">
										<div>
											<h3>How can we help?</h3>
										</div>
										<div className="cta-btns">
											<div>
												<h4>Interested in trying out the Customization Catalog 30 Days Free?</h4>
												<button className="btn_request_trial">
													<Link to="/request_trial_form">Request 30 Day Trial</Link>
												</button>
											</div>
											<div>
												<h4>Ready to see our Customizations in action?</h4>
												<ScheduleDemo />
											</div>
											<div>
												<h4>Got a question or suggestion?</h4>
												<button className="btn_send_message"><Link to="/contactForm">Send us a Message</Link></button>
											</div>
										</div>
									</div>
							</section>
						</div>
					</div>
					<div className="copyrights">
						<p>&copy; 2022 - <a href={this.props.href} className="bold" target="new">{this.props.name}.</a> All rights reserved</p>
					</div>
				</div>
			</div>
		);
	}
}

export default Contact;